import { FC } from 'react'
import { SurveyQuestionOption } from 'src/services/survey'

type DynamicSurveyFieldProps = {
  component: any
  options: SurveyQuestionOption[]
  value: string | undefined | null
  variant?: string
  translate?: string | null
  loading?: boolean
  disabled?: boolean
  isMultiple?: boolean
  numPad?: boolean
  questionDisplay?: string | null
  layout?: string | null
  handleResponse: (value: string | null | undefined) => void
  handleSearch: (value: string) => void
  valueRef?: null | undefined | SurveyQuestionOption | SurveyQuestionOption[]
  /** Question ID - used for file uploads to get presigned URLs */
  questionId?: string
  /** Validators ref - used for file upload constraints and pattern validation */
  validatorsRef?: Array<{ validationType: string; value: Record<string, unknown> }>
  /** Client-side pattern validation error */
  patternError?: string | null
  /** Callback to update pattern validation error */
  onPatternError?: (error: string | null) => void
  isSearchable?: boolean
}

const DynamicSurveyField: FC<DynamicSurveyFieldProps> = ({
  component,
  value,
  variant = 'light',
  options,
  handleResponse,
  handleSearch,
  loading = false,
  disabled = false,
  isMultiple = false,
  numPad = false,
  questionDisplay,
  layout,
  valueRef,
  questionId,
  validatorsRef,
  patternError,
  onPatternError,
  isSearchable = false,
}) => {
  const Component = component
  return (
    <Component
      value={value}
      handleResponse={handleResponse}
      handleSearch={handleSearch}
      options={options ?? []}
      loading={loading}
      disabled={disabled}
      isMultiple={isMultiple}
      numPad={numPad}
      variant={variant}
      valueRef={valueRef}
      questionDisplay={questionDisplay}
      layout={layout}
      questionId={questionId}
      validatorsRef={validatorsRef}
      patternError={patternError}
      onPatternError={onPatternError}
      isSearchable={isSearchable}
    />
  )
}
export default DynamicSurveyField
